var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenuArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.485,
    height: 11.377,
    viewBox: "0 0 6.485 11.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_FILL0_wght400_GRAD0_opsz48",
    d: "M248.8,185.377l-.8-.811,4.878-4.878L248,174.811l.8-.811,5.688,5.688Z",
    transform: "translate(-248 -174)",
    fill: "#4eb6ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuArrowIcon);
export default __webpack_public_path__ + "static/media/SideMenuArrowIcon.755f6644147088c456ca3846ee7184b7.svg";
export { ForwardRef as ReactComponent };